export const orderPartial = `
id
customer {
    id
}
createdAt
fullyPaid
refundable
name
unpaid
requiresShipping
note
tags
lineItems(first: 10) {
    edges {
    node {

        id
        name
        discountedTotalSet {
        shopMoney {
            amount
            currencyCode
        }
        }
        discountedUnitPriceSet {
        shopMoney {
            amount
            currencyCode
        }
        }
        currentQuantity
        product {
            id
            hasOnlyDefaultVariant
            featuredImage {
                id 
                originalSrc
            }
        }
        image {
            id
            altText
            originalSrc
        }
        variant {
        id
        displayName
        price
        inventoryQuantity
        sku
        image {
            id
            height
            width
            originalSrc
        }
        
        }
    }
    }
}

cancelledAt

displayFinancialStatus
displayFulfillmentStatus

fulfillments {
    id
    displayStatus
    trackingInfo {
    company
    number
    url
    }
}

currentSubtotalPriceSet {
    shopMoney {
    amount
    currencyCode
    }
}

currentTotalTaxSet {
    shopMoney {
    amount
    currencyCode
    }
}

currentTotalDiscountsSet {
    shopMoney {
    amount
    currencyCode
    }
}

currentTotalDutiesSet {
    shopMoney {
    amount
    currencyCode
    }
}

currentTotalPriceSet {
    shopMoney {
    amount
    currencyCode
    }
}

netPaymentSet {
    shopMoney {
    amount
    currencyCode
    }
}

totalShippingPriceSet {
    shopMoney {
    amount
    currencyCode
    }
}
`

export const draftOrderPartial = `
  id
  createdAt
  note2
  invoiceSentAt
  customer {
    id
    email
  }
  appliedDiscount {
    value
    valueType
  }
  name
  tags
  taxExempt
  totalTax
  totalPrice
  subtotalPrice

  shippingLine {
    id
    custom
    shippingRateHandle
    title
    originalPriceSet {
      shopMoney {
        amount
        currencyCode
      }
    }
  }

  lineItems(first: 10) {
    edges {
      node {
        id
        custom
        quantity
        name
        originalUnitPrice
        requiresShipping
        taxable
        appliedDiscount {
          value
          valueType
        }
        product {
          hasOnlyDefaultVariant
          featuredImage {
              id
              originalSrc
          }
        }
        variant {
          id
          displayName
          price
          inventoryQuantity
          sku
          image {
            id
            height
            width
            originalSrc
          }
        }
      }
    }
  }
`
